function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import BasicHeaderComponent from "segments/desktop/header/layouts/components/basic-header/basic-header-component";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { withAbTests } from "/contexts/ab-tests-context";
import SecondaryHeaderDesktopComponent from "segments/desktop/header/layouts/base-header/secondary-header/secondary-header-desktop/secondary-header-desktop-component";
import { getClusterDesktopLogo, getMiniSiteLinks, getMiniSiteUnifiedDesktopLogo, shouldHideGeneralPricingInMinisite } from "client/services/cluster-config-service/cluster-config-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { HEADER_SUBMENU_CLOSED, HEADER_SUBMENU_OPENED } from "/constants/bigbrain-event-types";
import { DESKTOP_HEADER_BASE_CLASS_NAME, SOLUTIONS_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
import classnames from "classnames";
import { StyledBaseHeaderDesktopComponent } from "./base-header-desktop-component.scss";
import ProductsSwitcher from "./products-switcher/products-switcher";
import LinkItemComponent from "./link-item/link-item-component";
import HeaderConstants from "../constants";
import { trackEvent } from "/services/bigbrain-service";
import StructuredHeader from "./structured-header/structured-header";
import { MENU_ID_TO_EVENT_KIND_MAP } from "./consts";
const BaseHeaderDesktopComponent = (props)=>{
    const [openedMenuId, setOpenedMenuId] = useState(null);
    const [showproductsSwithcer, setShowproductsSwithcer] = useState(null);
    const [isDynamicColor, setIsDynamicColor] = useState(props === null || props === void 0 ? void 0 : props.shouldUseDynamicColor);
    const _scrollInfo = {
        scrollTopWhenStartedScrollingUp: 0,
        prevScrollTop: 0,
        scrollingDown: true
    };
    const _basicHeader = useRef(null);
    const _headerRef = useRef(null);
    const { isSecondaryMenuNeeded, buttonConfig, pageClusterConfig, useProductMiniSiteConfig, showMenu, hideLogin, showButton, logoHref, logoSrc, logoPopup, simulateExistingAccountHeader, hideLanguagePicker, abTests, overrideClusterLogo, testTypeformContactSales, forceTypeformContactSalesExperience, showSuccessStoriesInHeader, shouldHaveEnhancedProducts, trackScroll, shouldUseDynamicColor, removeContactSalesButton } = props;
    useEffect(()=>{
        if (!openedMenuId) {
            removeClickOutsideEvent();
            return;
        }
        window.addEventListener("mousedown", handleClickOutsideMenu);
        return ()=>{
            removeClickOutsideEvent();
        };
    }, [
        openedMenuId
    ]);
    useEffect(()=>{
        if (isSecondaryMenuNeeded) {
            window.addEventListener("scroll", scrollListenerForSecondaryMenuUnification, {
                passive: true
            });
            return ()=>{
                window.removeEventListener("scroll", scrollListenerForSecondaryMenuUnification);
                removeClickOutsideEvent();
            };
        }
    }, []);
    const removeClickOutsideEvent = ()=>{
        window.removeEventListener("mousedown", handleClickOutsideMenu);
    };
    const handleClickOutsideMenu = (event)=>{
        if ((_headerRef === null || _headerRef === void 0 ? void 0 : _headerRef.current) && !_headerRef.current.contains(event.target)) {
            closeLinkMenu();
        }
    };
    const scrollListenerForSecondaryMenuUnification = (event)=>{
        {
            const header = document.querySelector(`.${DESKTOP_HEADER_BASE_CLASS_NAME}`);
            if (!header) {
                return;
            }
            let scrolledUpEnough = false;
            if (document.scrollingElement.scrollTop > _scrollInfo.prevScrollTop) {
                // scrolling down
                _scrollInfo.scrollingDown = true;
            } else {
                // scrolling up
                if (_scrollInfo.scrollingDown) {
                    _scrollInfo.scrollTopWhenStartedScrollingUp = document.scrollingElement.scrollTop;
                }
                scrolledUpEnough = _scrollInfo.scrollTopWhenStartedScrollingUp - document.scrollingElement.scrollTop > HeaderConstants.SCROLL_BACK_UP_THRESHOLD;
                _scrollInfo.scrollingDown = false;
            }
            _scrollInfo.prevScrollTop = document.scrollingElement.scrollTop;
            const showUnifiedBanner = document.scrollingElement.scrollTop > HeaderConstants.SCROLL_PIXEL_THRESHOLD && (_scrollInfo.scrollingDown || !scrolledUpEnough);
            if (document.scrollingElement.scrollTop > 0) {
                // shows the bottom menu border after scroll start
                header.classList.add("scroll-started");
            } else {
                header.classList.remove("scroll-started");
            }
            if (showUnifiedBanner) {
                header.classList.add("scrolled-threshold");
            } else {
                header.classList.remove("scrolled-threshold");
            }
        }
    };
    const openLinkMenu = (menuId, menuKind)=>{
        var _basicHeader_current;
        setOpenedMenuId(menuId);
        var _MENU_ID_TO_EVENT_KIND_MAP_menuId;
        trackEvent(HEADER_SUBMENU_OPENED, {
            kind: menuKind || ((_MENU_ID_TO_EVENT_KIND_MAP_menuId = MENU_ID_TO_EVENT_KIND_MAP[menuId]) !== null && _MENU_ID_TO_EVENT_KIND_MAP_menuId !== void 0 ? _MENU_ID_TO_EVENT_KIND_MAP_menuId : menuId)
        });
        _basicHeader === null || _basicHeader === void 0 ? void 0 : (_basicHeader_current = _basicHeader.current) === null || _basicHeader_current === void 0 ? void 0 : _basicHeader_current.forceShadow();
    };
    const closeLinkMenu = (e)=>{
        var _basicHeader_current;
        if (!openedMenuId) return;
        setOpenedMenuId(null);
        var _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId;
        trackEvent(HEADER_SUBMENU_CLOSED, {
            kind: (_MENU_ID_TO_EVENT_KIND_MAP_openedMenuId = MENU_ID_TO_EVENT_KIND_MAP[openedMenuId]) !== null && _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId !== void 0 ? _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId : openedMenuId
        });
        _basicHeader === null || _basicHeader === void 0 ? void 0 : (_basicHeader_current = _basicHeader.current) === null || _basicHeader_current === void 0 ? void 0 : _basicHeader_current.unforceShadow();
    };
    const getButtonConfig = ()=>{
        const { buttonType } = buttonConfig;
        let extraConfigs;
        switch(buttonType){
            case SIGNUP_BUTTON_TYPE:
                {
                    extraConfigs = {
                        buttonSize: "xs",
                        forceInputHide: true
                    };
                    break;
                }
            default:
                {
                    extraConfigs = {};
                    break;
                }
        }
        return _object_spread({}, buttonConfig, extraConfigs);
    };
    const getUnifiedDesktopLogoIfExists = ()=>{
        if (!isSecondaryMenuNeeded) return null;
        return getMiniSiteUnifiedDesktopLogo(pageClusterConfig, {
            useProductMiniSiteConfig
        });
    };
    const shouldShowMainPricingLink = ()=>{
        if (!isSecondaryMenuNeeded) return true;
        return !shouldHideGeneralPricingInMinisite(pageClusterConfig, {
            useProductMiniSiteConfig
        });
    };
    const renderUnifiedLinks = ()=>{
        const links = getMiniSiteLinks(pageClusterConfig, {
            onlyUnifiedLinks: true,
            useProductMiniSiteConfig
        });
        return links.map((link)=>/*#__PURE__*/ _jsx("div", {
                className: "link-item-component-wrapper",
                children: /*#__PURE__*/ _jsx(LinkItemComponent, {
                    title: link === null || link === void 0 ? void 0 : link.text,
                    url: link === null || link === void 0 ? void 0 : link.url
                })
            }, link === null || link === void 0 ? void 0 : link.text));
    };
    const renderBaseHeader = ()=>{
        const baseHeaderProps = {
            showMenu,
            hideLogin,
            showButton,
            buttonConfig: getButtonConfig(),
            openedMenuId,
            openLinkMenu,
            closeLinkMenu,
            shouldShowMainPricingLink,
            isSecondaryMenuNeeded,
            renderUnifiedLinks,
            simulateExistingAccountHeader,
            hideLanguagePicker,
            testTypeformContactSales,
            forceTypeformContactSalesExperience,
            showSuccessStoriesInHeader,
            shouldHaveEnhancedProducts,
            setShowproductsSwithcer,
            showproductsSwithcer,
            isDynamicColor,
            removeContactSalesButton
        };
        return /*#__PURE__*/ _jsx(StructuredHeader, _object_spread({}, baseHeaderProps));
    };
    const getMainPageLogo = ()=>{
        if (pageClusterConfig && !isSecondaryMenuNeeded) {
            const clusterMainLogo = getClusterDesktopLogo(pageClusterConfig, {
                useProductMiniSiteConfig
            });
            if (clusterMainLogo) {
                return {
                    logoHref: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.url) || clusterMainLogo.url,
                    logoSrc: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.src) || clusterMainLogo.src,
                    logoAltText: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.alt) || clusterMainLogo.alt
                };
            }
        }
        return {
            logoHref,
            logoSrc
        };
    };
    const unifiedDesktopLogo = getUnifiedDesktopLogoIfExists();
    const mainLogo = getMainPageLogo();
    const onDynamicColorChange = (newIsDynamicColor)=>{
        setIsDynamicColor(newIsDynamicColor);
    };
    return /*#__PURE__*/ _jsxs(StyledBaseHeaderDesktopComponent, {
        className: classnames(DESKTOP_HEADER_BASE_CLASS_NAME),
        ref: _headerRef,
        children: [
            /*#__PURE__*/ _jsx(BasicHeaderComponent, {
                ref: _basicHeader,
                imageHref: mainLogo.logoHref,
                imageSrc: mainLogo.logoSrc,
                imageAlt: mainLogo.logoAltText,
                secondaryLogoObject: unifiedDesktopLogo,
                logoPopup: logoPopup,
                isMenuOpen: !!openedMenuId,
                trackScroll: trackScroll,
                shouldUseDynamicColor: shouldUseDynamicColor,
                onDynamicColorChange: onDynamicColorChange,
                children: renderBaseHeader()
            }),
            isSecondaryMenuNeeded && /*#__PURE__*/ _jsx("div", {
                className: "secondary-header-wrapper",
                children: /*#__PURE__*/ _jsx(SecondaryHeaderDesktopComponent, {})
            }),
            showproductsSwithcer && /*#__PURE__*/ _jsx("div", {
                className: "products-switcher-wrapper",
                children: /*#__PURE__*/ _jsx(ProductsSwitcher, {
                    setShowproductsSwithcer: setShowproductsSwithcer,
                    showproductsSwithcer: showproductsSwithcer
                })
            })
        ]
    });
};
BaseHeaderDesktopComponent.defaultProps = {
    showMenu: true,
    showButton: true
};
export default withGenericConfig(withAbTests(BaseHeaderDesktopComponent));
